// import React, { useEffect, useRef } from "react";
// import { Offcanvas, Form, Button, Spinner } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { getProfile } from "../../redux/profile/profileSlice";
// import { sendInvite } from "../../redux/invite/inviteSlice";
// import { RxCross2 } from "react-icons/rx";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import { Box } from "@mui/system";

// const InviteDrawer = ({ open, onClose }) => {
//   const dispatch = useDispatch();
//   const profile = useSelector((state) => state.profile?.data);
//   const inviteStatus = useSelector((state) => state.invite?.status);

//   useEffect(() => {
//     dispatch(getProfile());
//   }, [dispatch]);

//   const formik = useFormik({
//     initialValues: {
//       copyemail: "",
//     },
//     validationSchema: Yup.object({
//       copyemail: Yup.string().required("Add some email id to send invite"),
//     }),
//     onSubmit: (values) => {
//       const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
//       const validEmails = values.copyemail.match(emailRegex) || [];

//       if (validEmails.length === 0) {
//         alert("No valid email addresses found");
//         return;
//       }


//       let joinLink = "";
//       if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
//         joinLink = "https://povital.com/it-recruiter-signup";
//       } else {
//         joinLink = "https://povital.com/benchsales-signup";
//       }

//       let userData = {
//         new_user_emails: validEmails,
//         refer_name: profile?.profile?.full_name,
//         refer_company: profile?.profile?.company_name,
//         join_link: joinLink,
//       };

//       dispatch(sendInvite(userData));
//     },
//   });

//   useEffect(() => {
//     if (inviteStatus === "sent_invitation_succeeded") {
//       formik.resetForm({
//         values: {
//           copyemail: "",
//         },
//       });
//     }
//   }, [inviteStatus]);

//   const textareaRef = useRef(null);

//   const autoResize = (textarea) => {
//     if (textarea) {
//       textarea.style.height = "auto"; // Reset the height
//       textarea.style.height = `${textarea.scrollHeight}px`; // Set to match content
//     }
//   };

//   return (
//     <Offcanvas
//       show={open}
//       onHide={onClose}
//       placement="end"
//       scroll={false}
//       backdrop={false}
//       style={{
//         border: "none",
//         marginTop: "65px",
//         width: "40%",
//         boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
//         <div style={{ padding: "20px", height: "100%", overflowY: "auto" }}>
//           {/* Close Icon */}
//           <div style={{ display: "flex", justifyContent: "space-between" }}>
//             {/* Title */}
//             <h4
//               style={{
//                 fontSize: "16px",
//                 fontWeight: "bold",
//                 // marginBottom: "10px",
//               }}
//             >
//               Build Connections with IT Recruiters
//             </h4>
//             <RxCross2
//               style={{
//                 fontSize: "15px",
//                 cursor: "pointer",
//                 marginLeft: "10px",
//                 marginBottom: "20px",
//               }}
//               onClick={onClose}
//             />
//           </div>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               marginBottom: "5px",
//             }}
//           >
//             {" "}
//             <p style={{ fontSize: "14px", color: "#666" }}>
//               Let's connect from upcoming roles through AI-powered platform.
//               Unlock your potential—embrace innovation and achieve more.
//             </p>
//             <Icon
//               icon="material-symbols-light:edit-document-outline-rounded"
//               style={{
//                 fontSize: "70px",
//                 marginLeft: 20,
//                 marginBottom: 4,
//                 color: "gray",
//               }}
//             />
//           </Box>
//           {/* Description */}

//           {/* List of Benefits */}
//           <h6
//             style={{
//               fontSize: "16px",
//               fontWeight: "bold",
//               marginBottom: "15px",
//             }}
//           >
//             List of Top benefits for FREE (Bench Sales Recruiters)
//           </h6>
//           <ul
//             style={{ listStyleType: "none", padding: 0, marginBottom: "20px" }}
//           >
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               ▪ Publish Unlimited Candidates and unlock unlimited hiring
//               potential.
//             </li>
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               ▪ Receive Daily Job Requirements delivered fast and efficiently.
//             </li>
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               ▪ Easily Apply to the latest jobs with AI-powered matching
//               assistance.
//             </li>
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               ▪ Share Unlimited Hotlists with a wide network of IT recruiters.
//             </li>
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               {`▪  Track Real-Time Updates on every submission you make.`}
//             </li>
//             <li
//               style={{ marginBottom: "10px", fontSize: "14px", color: "#333" }}
//             >
//               ▪ Get 5-Day Customer Support for all your queries.
//             </li>
//           </ul>

//           {/* Form */}
//           <Form onSubmit={formik.handleSubmit}>
//             <Form.Group style={{ marginBottom: "20px" }}>
//               <textarea
//                 name="copyemail"
//                 placeholder="Copy and paste the email address"
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 value={formik.values.copyemail}
//                 rows="5"
//                 ref={textareaRef}
//                 onInput={() => autoResize(textareaRef.current)}
//                 style={{
//                   width: "100%",
//                   padding: "10px",
//                   overflow: "hidden",
//                   resize: "none",
//                   border: "1px solid #ccc",
//                   borderRadius: "5px",
//                   fontSize: "14px",
//                 }}
//               />
//             </Form.Group>

//             {/* Error Message */}
//             {formik.touched.copyemail && formik.errors.copyemail ? (
//               <div
//                 style={{
//                   color: "red",
//                   fontSize: "12px",
//                   marginLeft: "20px",
//                   marginBottom: "10px",
//                 }}
//               >
//                 {formik.errors.copyemail}
//               </div>
//             ) : null}

//             {/* Note */}
//             <p
//               style={{ fontSize: "12px", color: "#666", marginBottom: "20px" }}
//             >
//               Note: Maximum invitation 1000 in a single click.
//             </p>

//             {/* Submit Button */}
//             <Button
//               type="submit"
//               onClick={formik.handleSubmit}
//               style={{
//                 backgroundColor: "#007bff",
//                 border: "none",
//                 borderRadius: "5px",
//                 padding: inviteStatus === "loading" ? "7px 40px" : "10px 20px",
//               }}
//             >
//               {inviteStatus === "loading" ? (
//                 <Spinner
//                   animation="border"
//                   size="sm"
//                   style={{ color: "#fff" }}
//                 />
//               ) : (
//                 "Let's Connect"
//               )}
//             </Button>
//           </Form>
//         </div>
//       </Offcanvas.Body>
//     </Offcanvas>
//   );
// };

// export default InviteDrawer;

import React, { useEffect, useRef, useState } from "react";
import { Offcanvas, Form, Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getProfile } from "../../redux/profile/profileSlice";
import { sendInvite } from "../../redux/invite/inviteSlice";
import { RxCross2 } from "react-icons/rx";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Box } from "@mui/system";
import { TextField } from "@mui/material";

const InviteDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const profile = useSelector((state) => state.profile?.data);
  const inviteStatus = useSelector((state) => state.invite?.status);
  const [showBenefits, setShowBenefits] = useState(false); // State to toggle benefits visibility
  const textFieldRef = useRef(null);

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      copyemail: "",
    },
    validationSchema: Yup.object({
      copyemail: Yup.string().required("Add some email id to send invite"),
    }),
    onSubmit: (values) => {
      const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
      const validEmails = values.copyemail.match(emailRegex) || [];

      if (validEmails.length === 0) {
        alert("No valid email addresses found");
        return;
      }

      let joinLink = "";
      if (profile?.profile?.role === "BENCH_SALES_RECRUITER") {
        joinLink = "https://povital.com/it-recruiter-signup";
      } else {
        joinLink = "https://povital.com/benchsales-signup";
      }

      let userData = {
        new_user_emails: validEmails,
        refer_name: profile?.profile?.full_name,
        refer_company: profile?.profile?.company_name,
        join_link: joinLink,
      };

      dispatch(sendInvite(userData));
      // onClose();
    },
  });

  useEffect(() => {
    if (inviteStatus === "sent_invitation_succeeded") {
      formik.resetForm({
        values: {
          copyemail: "",
        },
      });
    }
  }, [inviteStatus]);

  // Handle toggle benefits without affecting text field focus
  const handleToggleBenefits = () => {
    setShowBenefits((prev) => !prev);
  };

  // Handle text field focus explicitly on user interaction
  const handleTextFieldClick = () => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  };

  return (
    <Offcanvas
      show={open}
      onHide={onClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "40%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <div style={{ padding: "20px", height: "100%", overflowY: "auto" }}>
          {/* Close Icon */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "bold",
              }}
            >
              Build Connections with{" "}
              {profile?.profile?.role !== "BENCH_SALES_RECRUITER"
                ? " Bench Sales Recruiters"
                : "IT Recruiter"}
            </h4>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                marginLeft: "10px",
              }}
              onClick={onClose}
            />
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            <p style={{ fontSize: "14px", color: "#666" }}>
              Let's connect from upcoming roles through AI-powered platform.
              Unlock your potential—embrace innovation and achieve more.
            </p>
            <Icon
              icon="material-symbols-light:edit-document-outline-rounded"
              style={{
                fontSize: "70px",
                marginLeft: 20,
                marginBottom: 4,
                color: "gray",
              }}
            />
          </Box>
          {/* Toggleable Benefits Section */}
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "bold",
              marginBottom: "15px",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            onClick={handleToggleBenefits}
          >
            List of Top benefits for FREE (
            {profile?.profile?.role !== "BENCH_SALES_RECRUITER"
              ? "IT Recruiter"
              : "Bench Sales Recruiters"}
            )
            <Icon
              icon={showBenefits ? "mdi:chevron-up" : "mdi:chevron-down"}
              style={{ marginLeft: "8px", fontSize: "20px" }}
            />
          </h6>

          {profile?.profile?.role === "BENCH_SALES_RECRUITER" &&
            showBenefits && (
              <ul
                style={{
                  listStyleType: "none",
                  padding: 0,
                  marginBottom: "20px",
                }}
              >
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Publish Unlimited Candidates and unlock unlimited hiring
                  potential.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Receive Daily Job Requirements delivered fast and
                  efficiently.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Easily Apply to the latest jobs with AI-powered matching
                  assistance.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Share Unlimited Hotlists with a wide network of IT
                  recruiters.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  {`▪ Track Real-Time Updates on every submission you make.`}
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Get 5-Day Customer Support for all your queries.
                </li>
              </ul>
            )}
          {profile?.profile?.role !== "BENCH_SALES_RECRUITER" &&
            showBenefits && (
              <ul
                style={{
                  listStyleType: "none",
                  padding: 0,
                  marginBottom: "20px",
                }}
              >
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Post Unlimited Jobs and receive the fastest responses from
                  your bench sales team and vendors.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Connect Instantly with your trusted and verified vendors.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Track Real-Time Updates on every submission for complete
                  transparency.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Access Unlimited Hotlists through a vast network of bench
                  sales recruiters.
                </li>
                <li
                  style={{
                    marginBottom: "10px",
                    fontSize: "14px",
                    color: "#333",
                  }}
                >
                  ▪ Get 5-Day Customer Support for all your queries.
                </li>
              </ul>
            )}

          {/* Form */}
          <Form onSubmit={formik.handleSubmit}>
            <Form.Group style={{ marginBottom: "20px" }}>
              <TextField
                name="copyemail"
                placeholder="Enter email addresses (separated by commas or spaces)"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.copyemail}
                multiline
                rows={5}
                inputRef={textFieldRef}
                onClick={handleTextFieldClick}
                fullWidth
                variant="outlined"
                InputProps={{
                  style: {
                    fontSize: "14px",
                    borderRadius: "5px",
                  },
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: "#ccc",
                    },
                    "&:hover fieldset": {
                      borderColor: "#ccc",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#3856a6",
                    },
                  },
                }}
              />
            </Form.Group>

            {/* Error Message */}
            {formik.touched.copyemail && formik.errors.copyemail ? (
              <div
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginLeft: "20px",
                  marginBottom: "10px",
                }}
              >
                {formik.errors.copyemail}
              </div>
            ) : null}

            {/* Note */}
            <p
              style={{ fontSize: "12px", color: "#666", marginBottom: "20px" }}
            >
              Note: Maximum invitation 1000 in a single click.
            </p>

            {/* Submit Button */}
            <Button
              type="submit"
              onClick={formik.handleSubmit}
              style={{
                backgroundColor: "#3856a6",
                border: "none",
                borderRadius: "3px",
                padding: inviteStatus === "loading" ? "7px 40px" : "10px 20px",
              }}
            >
              {inviteStatus === "loading" ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{ color: "#fff" }}
                />
              ) : (
                "Let's Connect"
              )}
            </Button>
          </Form>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default InviteDrawer;
